/** Parsea números con coma o punto decimal. */
export const parseDecimalValue = (value) => {
  if (typeof value === 'string') {
    const normalized = value.replace(',', '.');
    const parsed = parseFloat(normalized);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return parseFloat(value) || 0;
};

/** Totales de línea con descuento % opcional e IVA incluido o no. */
export const calculateItemTotals = (item) => {
  const cantidad = parseDecimalValue(item.cantidad);
  const precio = parseDecimalValue(item.precio);
  const discountRate = Math.min(100, Math.max(0, parseDecimalValue(item.descuento_porcentaje))) / 100;
  const precioBruto = cantidad * precio;
  const precioTotal = precioBruto * (1 - discountRate);
  const ivaRate = (item.iva_porcentaje || 22) / 100;

  if (item.ivaIncluded) {
    item.subtotal = precioTotal / (1 + ivaRate);
    item.iva_monto = precioTotal - item.subtotal;
    item.total = precioTotal;
  } else {
    item.subtotal = precioTotal;
    item.iva_monto = precioTotal * ivaRate;
    item.total = item.subtotal + item.iva_monto;
  }
  return item;
};

/** Redondeo al peso más cercano (>= ,50 hacia arriba). Devuelve línea de ajuste o null. */
export const buildRoundingLineItem = (items) => {
  const billable = (items || []).filter((i) => !i.es_redondeo && !i.es_no_facturable);
  const sum = billable.reduce((s, i) => s + (Number(i.total) || 0), 0);
  const rounded = Math.round(sum);
  const diff = Math.round((rounded - sum) * 100) / 100;
  if (Math.abs(diff) < 0.005) return null;

  const sign = diff > 0 ? 1 : -1;
  const absDiff = Math.abs(diff);
  const line = {
    id: 'rounding-adjustment',
    concepto: diff > 0 ? 'Redondeo' : 'Redondeo (ajuste)',
    cantidad: 1,
    precio: absDiff,
    unidad: 'un',
    iva_porcentaje: 0,
    ivaIncluded: false,
    es_redondeo: true,
    es_no_facturable: true,
    indicador_facturacion: 5,
    cod_item: 'REDONDEO',
    descuento_porcentaje: 0,
  };
  calculateItemTotals(line);
  if (sign < 0) {
    line.subtotal = -Math.abs(line.subtotal);
    line.iva_monto = 0;
    line.total = -absDiff;
    line.precio = -absDiff;
  }
  return line;
};

export const sumItemsTotal = (items) =>
  (items || []).reduce((s, i) => s + (Number(i.total) || 0), 0);
